import { useEffect } from "react";
import { formatPrice } from "#/lib/formatters";
import { useDisplayPrice } from "./use-display-price";
import { useTradeSymbol } from "./use-trade-symbol";

export function useTradeTitle() {
	const market = useTradeSymbol();
	// Same source as the orderbook center value: last trade while live, mark
	// when stale — so the tab title and the book never show conflicting prices.
	const { price } = useDisplayPrice();

	useEffect(() => {
		const text = price > 0 ? formatPrice(price) : "-";
		document.title = `${text} | ${market.coin} | Tenbagger`;
	}, [price, market.coin]);
}
